import Icon from '~/components/Icon';
import { useCurrencyFormatter } from '~/utils/formatters';

export default function ShopNowReturnCredit({
  credit,
  incentive,
}: {
  credit: number;
  incentive: number;
}) {
  const hasBonus = incentive > 0;
  const currencyFormatter = useCurrencyFormatter();

  return (
    <section className="space-y-3">
      <div className="flex flex-col gap-3 rounded-xl border border-primary/20 bg-primary/5 p-5">
        {/* Heading */}
        <p className="text-sm font-semibold tracking-wide text-primary uppercase">
          Your credit
        </p>

        <div>
          {/* Balance amount */}
          <span className="text-xl font-bold text-gray-900">
            {currencyFormatter(credit)}
          </span>

          {/* Incentive pill */}
          {hasBonus && (
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-sm font-semibold text-primary/90 shadow-xs">
              <Icon icon="CheckCircle" className="h-4 w-4 text-primary" />+{' '}
              {currencyFormatter(incentive)} bonus
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
